// src/pages/MaintenancePage.jsx
import React, { useState, useEffect } from 'react';
import { getApiUrl } from '../../config/api';
import './MaintenancePage.css'; // Importa el CSS para esta página
// Si tienes un logo o icono del servidor, puedes importarlo aquí
// import serverLogo from '../assets/your-server-logo.png';

const MaintenancePage = () => {
  const [config, setConfig] = useState({
    maintenanceTitle: '¡Estamos de mantenimiento!',
    maintenanceMessage: 'Actualmente estamos realizando mejoras y actualizaciones en nuestra web para ofrecerte la mejor experiencia posible.',
    maintenanceEndTime: '',
    showProgressBar: false,
    maintenanceProgress: 0
  });

  useEffect(() => {
    // Cargar configuración desde el servidor
    const fetchConfig = async () => {
      try {
        const response = await fetch(getApiUrl('/system-config'));
        if (response.ok) {
          const data = await response.json();
          setConfig(data);
        }
      } catch (err) {
        console.log('No se pudo cargar la configuración, usando valores por defecto');
      }
    };

    fetchConfig();
  }, []);

  // Función para formatear la fecha de finalización
  const formatEndTime = (endTime) => {
    if (!endTime) return null;
    const date = new Date(endTime);
    return date.toLocaleString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="maintenance-container">
      {/* Puedes añadir tu logo aquí si lo deseas */}
      {/* <img src={serverLogo} alt="Logo de Proyecto RP" className="maintenance-logo" /> */}

      <h1 className="maintenance-title">{config.maintenanceTitle}</h1>
      <p className="maintenance-message">
        {config.maintenanceMessage}
      </p>

      {/* Mostrar tiempo estimado de finalización */}
      {config.maintenanceEndTime && (
        <p className="maintenance-eta">
          <strong>Tiempo estimado de finalización:</strong><br />
          {formatEndTime(config.maintenanceEndTime)}
        </p>
      )}

      {/* Mostrar barra de progreso si está activada */}
      {config.showProgressBar && (
        <div className="maintenance-progress-container">
          <p className="maintenance-progress-label">
            Progreso del mantenimiento: {config.maintenanceProgress}%
          </p>
          <div className="maintenance-progress-bar">
            <div 
              className="maintenance-progress-fill"
              style={{ width: `${config.maintenanceProgress}%` }}
            ></div>
          </div>
        </div>
      )}
      
      <p className="maintenance-follow-us">
        Mientras tanto, puedes seguirnos en nuestras redes sociales o unirte a nuestro Discord para estar al tanto de las novedades:
      </p>
      <div className="maintenance-social-links">
        {/* Botón de Discord */}
        <a 
          href="https://discord.gg/GXr37Wr8CJ"
          target="_blank" 
          rel="noopener noreferrer" 
          className="maintenance-social-button discord"
        >
          Discord
        </a>
        
        {/* Botón de TikTok */}
        <a 
          href="https://www.tiktok.com/@riasbaixas_pd"
          target="_blank" 
          rel="noopener noreferrer" 
          className="maintenance-social-button tiktok"
        >
          TikTok
        </a>
      </div>
      
      <p className="maintenance-thank-you">¡Gracias por tu comprensión!</p>
    </div>
  );
};

export default MaintenancePage;